import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Signing from './components/Signing';
import WhenItBreaks from './components/WhenItBreaks';
import '@fontsource-variable/inter';
import './styles.css';
import { watchForTheTrail } from './trail';
import { reportWhatBreaks } from './reporting';
import { applyStoredTheme } from './theme';

/*
 * Before anything renders, so the first press of the session is recorded. A
 * fault found in the first ten seconds is the one a new person reports.
 */
watchForTheTrail();

/*
 * AND THE FAULTS GO SOMEWHERE — #265. Immediately after the trail, because it
 * hooks the trail: everything that breaks already arrives at one place, and
 * this is what carries it out of the browser. Before anything renders, so a
 * screen that dies on its first paint is still reported.
 */
reportWhatBreaks();

/*
 * Also before anything renders, and for the same kind of reason: the theme was
 * only ever applied from inside the signed-in shell, so every screen up to and
 * including sign-in painted in whatever bare :root happens to be. Setting it
 * here means the first thing anyone sees is the theme they actually have, and
 * there is no flash of the other one on the way.
 */
applyStoredTheme();

/*
 * THE SIGNING PAGE IS DECIDED HERE, BEFORE THE APP EXISTS — #216.
 *
 * Somebody opening /sign/<token> has no account and must never need one. If
 * this branch lived inside <App/> they would still be mounting the shell: the
 * store, the auth listener, the realtime subscriptions, the sign-in screen that
 * appears when none of it resolves. All of that is machinery for people who
 * belong to a workspace, and every piece of it is another way for an executive
 * with one question to end up looking at a login box.
 *
 * So the address is read first, and the two pages are alternatives rather than
 * one page inside the other.
 */
const signing = window.location.pathname.match(/^\/sign\/(.+)$/);

/*
 * AROUND BOTH PAGES, AND OUTSIDE EVERYTHING — #254. A fault while drawing any
 * screen used to take the whole page and leave white, which is the one report
 * that carries no information at all. It wraps the signing page too, and that
 * is not an afterthought: the person opening one is an approver from outside
 * the company with a single document to sign, no account, and nobody to ask.
 * A white page there is the worst audience this app has for one.
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WhenItBreaks>
      {signing ? <Signing token={decodeURIComponent(signing[1])} /> : <App />}
    </WhenItBreaks>
  </React.StrictMode>
);
